
function bmHeroOverlay_SetHeight() {
	let $height = jQuery(".bm-Hero-Overlay--Fluid-Height .bm-Hero-Overlay__Content").height() + 350;
	jQuery(".bm-Hero-Overlay .owl-item").css("height", $height);
}

window.addEventListener('load', bmHeroOverlay_SetHeight);
window.addEventListener('resize',bmHeroOverlay_SetHeight);